import { Button, Stack } from '@mui/material';
import get from 'lodash-es/get';

import { useConstants } from '../../hooks/useConstants';

// used to select a contract active status in the filter menu
function ActiveStatusFilterMenu({ modifyFilters, closeFilterMenu }) {
  const { constants } = useConstants();
  const activeStatusOptions = get(constants, 'CONTRACT.ACTIVE_STATUS_OPTIONS', []);

  // apply filter and close menu
  const applyActiveStatusFilter = (activeStatus) => {
    modifyFilters('active_status', activeStatus);
    closeFilterMenu();
  };

  return (
    <Stack spacing={1}>
      {activeStatusOptions.map((option) => (
        <Button key={option[0]} onClick={() => applyActiveStatusFilter(option[0])}>
          {option[1]}
        </Button>
      ))}
    </Stack>
  );
}

export default ActiveStatusFilterMenu;
